// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"b4d93a83","900":"a1e746be","931":"27172734"}[chunkId] + ".chunk.js";
};